// extracted by mini-css-extract-plugin
module.exports = {"img":"style_img__dMZYA","imageContainer":"style_imageContainer__3tnon","closeIcon":"style_closeIcon__3mGh1"};